module.exports = __webpack_public_path__ + "img/IMG_3119_L_Black.b171b41d.jpg";